"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = isSSR;
/**
 * Returns `true` if server-side
 * @returns boolean
 */
function isSSR() {
    return typeof window === 'undefined';
}
//# sourceMappingURL=isSSR.js.map